import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-driveb-file-details",
    templateUrl: "./file-details.component.html",
    styleUrls: ["./file-details.component.scss"],
    standalone: false
})
export class FileDetailsComponent implements OnInit {
  @Input() file: File;
  @Output() onClickSave = new EventEmitter();
  @Output() onClickRemove = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
